// extracted by mini-css-extract-plugin
module.exports = {"accountSettings":"styles_accountSettings__2zyJx"};